import { render, staticRenderFns } from "./DashboardControls.vue?vue&type=template&id=55d8bbc2&scoped=true&"
import script from "./DashboardControls.vue?vue&type=script&lang=js&"
export * from "./DashboardControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d8bbc2",
  null
  
)

export default component.exports